module.exports = __webpack_public_path__ + "img/bicc_xmas.5d36ea36.png";